import themed from '@/ui/Theme/themed'
import Card from './Card'

const themedCard = themed(Card)

export { themedCard as Card }
export default Card



// WEBPACK FOOTER //
// ./ui/Card/index.js